import { useRef } from "react";
import { proxy, useSnapshot } from "valtio";
import { BooleanDict } from "../types/keys/type-key-of";

export const useShouldValidate = <T extends object>(fields: T) => {
  const state = useRef(
    proxy({
      isBlurred: proxy({} as BooleanDict<T>),
      isDirty: proxy({} as BooleanDict<T>),
      isFocused: proxy({} as BooleanDict<T>),
    })
  );

  const onBlur = <Key extends keyof T>(key: Key) => {
    state.current.isBlurred[key] = true;
    state.current.isFocused[key] = false;
  };

  const onFocus = <Key extends keyof T>(key: Key) => {
    state.current.isBlurred[key] = false;
    state.current.isFocused[key] = true;
  };

  const setDirty = <Key extends keyof T>(key: Key) => {
    state.current.isDirty[key] = true;
  };

  const fieldShouldValidate = <Key extends keyof T>(key: Key) => {
    return shouldValidate(
      state.current.isDirty[key],
      state.current.isBlurred[key]
    );
  };

  return {
    state: useSnapshot(state.current),
    onBlur,
    onFocus,
    setDirty,
    shouldValidate: fieldShouldValidate,
  };
};

export function shouldValidate(isDirty: boolean, blurred: boolean) {
  return isDirty && blurred;
}
